import React from 'react'

export default class WhatAboutUs extends React.Component {
    render() {
        return (
            <section className="what-about-us">

                <ul>
                    <li>
                        <figure>
                            <img src={require("assets/images/persona-halil.svg")} alt="Halil İbrahim Çakıroğlu" />
                        </figure>
                        <h4 className="name">HALIL IBRAHIM CAKIROGLU</h4>
                        <p className="about">He is the Creator. He created the Sketchize with React.js in 6 days and rested on the 7th. He said, “Let there be a beautifully coded web site,” and there was web site.</p>
                        <div className="authors-profile"><a href="https://www.linkedin.com/in/selfishprimate/" target="_blank" rel="noopener noreferrer">Contact me!</a></div>
                    </li>

                    <li>
                        <figure>
                            <img src={require("assets/images/persona-volkan.svg")} alt="Satoshi Zikituttu" />
                        </figure>
                        <h4 className="name">VOLKAN SENGUL</h4>
                        <p className="about">React Maestro. Also known as the founder of ShitCoin. He has a lot of ShitCoins. Unfortunatelly, he can use his coins only in public toilets.</p>
                        <div className="authors-profile"><a href="https://www.linkedin.com/in/volkansengul/" target="_blank" rel="noopener noreferrer">Contact me!</a></div>
                    </li>
                    <li>
                        <figure>
                            <img src={require("assets/images/persona-kenan.svg")} alt="Bonny Deep" />
                        </figure>
                        <h4 className="name">KENAN GUNDOGAN</h4>
                        <p className="about">What a strange man he is! Someone says that one day he was walking on the street and he got tired; so he started to run, and he never stopped.</p>
                        <div className="authors-profile"><a href="https://www.linkedin.com/in/kenangundogan/" target="_blank" rel="noopener noreferrer">Contact me!</a></div>
                    </li>
                </ul>

            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/WhatAboutUs/WhatAboutUs.js